export default __webpack_public_path__ + "static/media/icon-assets-pressure.4d323261.svg";